import { Collapse, IconButton, Typography } from '@paintscout/ui'
import React from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const useStyles = makeStyles<Theme, DetailCardProps>((theme: Theme) => ({
  root: {
    background: theme.paintscout.palette.brand.Neutral.P96,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(1, 1, 1.25, 1),
    borderRadius: 4
  },
  label: {
    ...theme.typography.overline,
    color: theme.paintscout.palette.brand.Neutral.P60,
    whiteSpace: 'nowrap',
    marginTop: '0.35rem',
    fontWeight: 500,
    marginBottom: '0.2rem'
  },
  value: {
    fontSize: '1.2rem'
  },
  iconButton: {
    marginLeft: theme.spacing(0.25),
    marginBottom: theme.spacing(0.4)
  },
  icon: {
    transform: ({ expanded }) => (expanded ? 'rotate(180deg)' : 'rotate(0deg)'),
    transition: 'transform 0.3s'
  }
}))

interface DetailCardProps {
  label: string
  value: string | number
  children?: React.ReactNode
  expanded?: boolean
  onExpand?: () => void
}

export function DetailCard(props: DetailCardProps) {
  const classes = useStyles({ ...props })
  const { label, children, expanded, onExpand } = props
  const value = typeof props.value === 'number' ? props.value.toFixed(2).toLocaleString() : props.value

  return (
    <div className={classes.root}>
      <Typography className={classes.label}>{label}</Typography>
      <Typography variant="h3" format="hours" className={classes.value}>
        {value}
        {!!children && (
          <IconButton onClick={onExpand} className={classes.iconButton} size="small">
            <ExpandMoreIcon className={classes.icon} />
          </IconButton>
        )}
      </Typography>
      {!!children && <Collapse show={expanded}>{children}</Collapse>}
    </div>
  )
}
